import { render, staticRenderFns } from "./TicketNextAndPreviousButtons.vue?vue&type=template&id=802f2fd6&scoped=true&"
import script from "./TicketNextAndPreviousButtons.vue?vue&type=script&lang=ts&"
export * from "./TicketNextAndPreviousButtons.vue?vue&type=script&lang=ts&"
import style0 from "./TicketNextAndPreviousButtons.vue?vue&type=style&index=0&id=802f2fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802f2fd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('802f2fd6')) {
      api.createRecord('802f2fd6', component.options)
    } else {
      api.reload('802f2fd6', component.options)
    }
    module.hot.accept("./TicketNextAndPreviousButtons.vue?vue&type=template&id=802f2fd6&scoped=true&", function () {
      api.rerender('802f2fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketNextAndPreviousButtons.vue"
export default component.exports